// extracted by mini-css-extract-plugin
export default {"contactInformationSection":"contact_information_section-module___contactInformationSection___bc1578f2"};